import { jsxs as D, Fragment as L, jsx as i } from "react/jsx-runtime";
import { H as v } from "./HeroBanner-v7s2AnB2.js";
import { F as H, S as K, I as h, C as O, a as z } from "./InfoCardGrid-CVf_t4co.js";
import { S as q } from "./Section-DOeCOW54.js";
import { G as T } from "./Gap-BresIL53.js";
import { T as E } from "./useMediaQuery-BZAMobKw.js";
import { C as J } from "./CardGrid-JhNXXSJv.js";
import { A as Q } from "./AutoPlayCardCarousel-DiWmC0a4.js";
const V = "elo-tablet", W = "elo-desktop", p = {
  "details-page": "elo-details-page",
  "apartment-page__heading": "elo-apartment-page__heading",
  "apartment-page__grid": "elo-apartment-page__grid",
  tablet: V,
  desktop: W
}, X = (x) => x.map((t) => ({
  type: "apartment",
  data: {
    ...t
  }
})), Y = (x) => {
  const t = x.indexOf("</p>");
  if (t === -1)
    return [x, ""];
  const l = x.slice(0, t + 4), k = x.slice(t + 4);
  return [l, k];
}, e = ({
  floatButtonText: x,
  heroBanner: t,
  spaceIntroduction: l,
  infoCardGrid: k,
  infoBanner: s,
  contactBanner: g,
  apartmentCardCarousel: b,
  apartmentDetailsCardCarousel: m,
  infoCardGridTwo: y
}) => {
  const A = (t == null ? void 0 : t.imageUrl) && (t == null ? void 0 : t.title) && (t == null ? void 0 : t.subtitle) && (t == null ? void 0 : t.primaryButtonText) && (t == null ? void 0 : t.secondaryButtonText) && (t == null ? void 0 : t.carouselImages), S = (l == null ? void 0 : l.lat) && (l == null ? void 0 : l.lng) && (l == null ? void 0 : l.label) && (l == null ? void 0 : l.shortDescription), U = k == null ? void 0 : k.infoCardData, F = (y == null ? void 0 : y.heading) && (y == null ? void 0 : y.infoCardData), M = (b == null ? void 0 : b.apartmentCardData) && (b == null ? void 0 : b.title), N = (s == null ? void 0 : s.title) && (s == null ? void 0 : s.src) && (s == null ? void 0 : s.subtitle), P = (m == null ? void 0 : m.apartmentCardData) && (m == null ? void 0 : m.apartmentCardData.length) > 0 && (m == null ? void 0 : m.title), j = (g == null ? void 0 : g.title) && (g == null ? void 0 : g.name) && (g == null ? void 0 : g.phoneNumber), [R, _] = Y(l.shortDescription);
  return /* @__PURE__ */ D(L, { children: [
    A && /* @__PURE__ */ i(
      v,
      {
        imageUrl: t.imageUrl,
        imageAlt: t.imageAlt,
        statusText: t.statusText,
        title: t.title,
        isDark: !0,
        subtitle: t.subtitle,
        secondarySubtitle: t.secondarySubtitle,
        primaryButtonText: t.primaryButtonText,
        secondaryButtonText: t.secondaryButtonText,
        anchorLink: "#space-introduction",
        onOpenModal: function() {
          console.error("Function not implemented.");
        },
        carouselImages: t.carouselImages
      }
    ),
    x && /* @__PURE__ */ i(H, { href: "#contact", iconLeft: "Contact", children: x }),
    /* @__PURE__ */ D(q, { className: p["details-page"], children: [
      S && /* @__PURE__ */ i(
        K,
        {
          type: "building",
          lat: l.lat,
          lng: l.lng,
          googleMapsApiKey: l.googleMapsApiKey,
          label: l.label,
          shortDescription: R,
          longDescription: _,
          downloadFloorPlanButtonText: l.downloadFloorPlanButtonText,
          showMoreButtonText: _.length > 0 ? l.showMoreButtonText : "",
          showLessButtonText: _.length > 0 ? l.showLessButtonText : ""
        }
      ),
      U && /* @__PURE__ */ D(L, { children: [
        /* @__PURE__ */ i(
          h,
          {
            heading: k.heading,
            infoCardData: k.infoCardData,
            isTransparent: !0
          }
        ),
        /* @__PURE__ */ i(T, {})
      ] }),
      F && /* @__PURE__ */ D(L, { children: [
        /* @__PURE__ */ i(
          h,
          {
            heading: y.heading,
            infoCardData: y.infoCardData
          }
        ),
        /* @__PURE__ */ i(T, {})
      ] }),
      M && /* @__PURE__ */ D("div", { className: p["apartment-page__grid"], children: [
        /* @__PURE__ */ i(
          E,
          {
            type: "heading",
            size: "medium",
            extraClass: p["apartment-page__heading"],
            children: b == null ? void 0 : b.title
          }
        ),
        /* @__PURE__ */ i(
          J,
          {
            cardData: X(b.apartmentCardData)
          }
        )
      ] }),
      j && /* @__PURE__ */ i(L, { children: /* @__PURE__ */ i(
        O,
        {
          variant: "transparent",
          src: g.src,
          subtitle: g.subtitle,
          title: g.title,
          name: g.name,
          jobTitle: g.jobTitle || "",
          phoneNumber: g.phoneNumber,
          linkLabel: g.linkLabel,
          linkUrl: g.linkUrl,
          iconLeft: g.iconLeft,
          iconRight: g.iconRight,
          email: g.email
        }
      ) }),
      N && /* @__PURE__ */ D(L, { children: [
        /* @__PURE__ */ i(
          z,
          {
            variant: "secondary",
            alignLeft: !1,
            src: s.src,
            subtitle: s.subtitle,
            title: s.title,
            descriptionTitle: s.descriptionTitle,
            description: s.description,
            linkLabel: s.linkLabel,
            linkUrl: s.linkUrl,
            iconLeft: s.iconLeft,
            iconRight: s.iconRight
          }
        ),
        /* @__PURE__ */ i(T, {})
      ] }),
      P && /* @__PURE__ */ D(L, { children: [
        /* @__PURE__ */ i(
          Q,
          {
            apartmentCardData: m.apartmentCardData,
            title: m.title
          }
        ),
        /* @__PURE__ */ i(T, {})
      ] })
    ] })
  ] });
};
export {
  e as ApartmentPage
};
